import { useScopedAppFlagStore } from '@frontend/scope';
import { autoRecallFeatureFlags } from '../../constants';
import { useIsMulti } from '../use-is-multi';

export const useHasAutoRecallAnalyticsFeature = () => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const isAutoRecallAnalyticsDisabled = getFeatureFlagValue(autoRecallFeatureFlags.disableAutoRecallInAnalytics);
  const { isMulti } = useIsMulti();

  if (isMulti) {
    // Auto recall analytics is not supported for multi-locations
    return false;
  }

  return !isAutoRecallAnalyticsDisabled;
};
